import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SEO = () => {
  const { language, t } = useLanguage();

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <title>{t('seo.title')}</title>
      <meta name="description" content={t('seo.description')} />
      <meta property="og:title" content={t('seo.title')} />
      <meta property="og:description" content={t('seo.description')} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={language === 'ja' ? 'ja_JP' : 'vi_VN'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t('seo.title')} />
      <meta name="twitter:description" content={t('seo.description')} />
    </Helmet>
  );
};

export default SEO;
